import { doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "../firebase";

class EventRequestAPI {
  static collectionName = "eventsRequests";

  /**
   * Mark a member event request done once the event it asked for exists. Call
   * ONLY after the event write succeeds; until then the request stays pending
   * and retryable. eventsRequests has no field-level rules, so the created
   * event is linked back as well.
   */
  static async markConverted(requestId, eventID) {
    await updateDoc(doc(db, EventRequestAPI.collectionName, requestId), {
      status: "approved",
      convertedEventId: eventID,
      convertedAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
  }
}

export default EventRequestAPI;
